import { render, staticRenderFns } from "./EditGroupSidebarMenu.vue?vue&type=template&id=6befcba8&scoped=true&"
import script from "./EditGroupSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./EditGroupSidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./EditGroupSidebarMenu.vue?vue&type=style&index=0&id=6befcba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6befcba8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6befcba8')) {
      api.createRecord('6befcba8', component.options)
    } else {
      api.reload('6befcba8', component.options)
    }
    module.hot.accept("./EditGroupSidebarMenu.vue?vue&type=template&id=6befcba8&scoped=true&", function () {
      api.rerender('6befcba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/EditGroupSidebarMenu.vue"
export default component.exports